import {Params} from '@feathersjs/feathers'

import {Discount, DiscountId, ProviderId} from '../../types'

import * as feathersService from '../feathers'

export type DiscountRequest = Omit<Discount, 'id'>

export const RESOURCE = 'discount'

const get = async (params?: Params) => feathersService.find<Discount>(RESOURCE, params)

export const getByProvider = async (provider: ProviderId, params?: Params) => {
  const parameters = {
    ...params,
    query: {
      ...params?.query,
      provider,
    },
  }
  return get(parameters)
}

export const getById = async (id: DiscountId) => feathersService.get<Discount>(RESOURCE, id)

export const create = async (payload: DiscountRequest) =>
  feathersService.create<Discount, DiscountRequest>(RESOURCE, payload)

export const createMultiple = async (payload: DiscountRequest[]) =>
  payload.length > 0
    ? feathersService.createMultiple<Discount, DiscountRequest>(RESOURCE, payload)
    : Promise.resolve([])

export const update = async (payload: Discount, id: DiscountId) =>
  feathersService.update<Discount>(RESOURCE, id, payload)

export const updateMultiple = async (payload: Discount, ids: DiscountId[]) =>
  Promise.all(ids.map(id => update(payload, id)))

export const patch = async (payload: Partial<DiscountRequest>, id: DiscountId) =>
  feathersService.patch<Discount>(RESOURCE, id, payload)

export const patchMultiple = async (payload: Partial<DiscountRequest>, ids: DiscountId[]) =>
  Promise.all(ids.map(id => patch(payload, id)))

export const remove = async (id: DiscountId) => feathersService.remove<Discount>(RESOURCE, id)

export const removeMultiple = async (ids: DiscountId[]) => Promise.all(ids.map(id => remove(id)))
